module.exports = __webpack_public_path__ + "img/ofppt-logo.636c5add.png";